import React, { useEffect, useState } from "react";
import {
  Box,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import RegionSkeleton from "./region-skeleton";

const WebRegionToggle = ({
  dubaiUrl = "https://www.99gift.ae/",
  indiaUrl = "https://www.99gift.in/",
  loading = false,
}) => {
  // Current website ke domain ke according region detect hoga
  const getCurrentRegion = () => {
    if (typeof window === "undefined") {
      return "INDIA";
    }

    return window.location.hostname.endsWith("99gift.ae")
      ? "UAE"
      : "INDIA";
  };

  const [region, setRegion] = useState(getCurrentRegion);

  // Browser Back / Forward ke case ko handle karega
  useEffect(() => {
    const handlePageShow = () => {
      setRegion(getCurrentRegion());
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const handleRegionChange = (event) => {
    const selectedRegion = event.target.value;

    setRegion(selectedRegion);

    const url =
      selectedRegion === "UAE"
        ? dubaiUrl
        : indiaUrl;

    window.location.href = url;
  };

  if (loading) {
    return <RegionSkeleton />;
  }

  return (
    <Box>
      <Select
        value={region}
        onChange={handleRegionChange}
        size="small"
        displayEmpty
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 1,
              borderRadius: "10px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
            },
          },
        }}
        sx={{
          ml: 2,
          minWidth: 100,
          height: 50,
          borderRadius: "4px",
          backgroundColor: "#fff",

          "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #E5E7EB",
          },

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D1D5DB",
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D1D5DB",
          },

          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            padding: "8px 12px",
          },
        }}
      >
        {/* Dubai */}
        <MenuItem value="UAE">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              component="img"
              src="https://flagcdn.com/w40/ae.png"
              alt="UAE"
              sx={{
                width: 24,
                height: 16,
                objectFit: "cover",
                borderRadius: "2px",
              }}
            />

            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#2B3445",
                fontFamily: "Be Vietnam Pro",
              }}
            >
              UAE
            </Typography>
          </Box>
        </MenuItem>

        {/* India */}
        <MenuItem value="INDIA">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              component="img"
              src="https://flagcdn.com/w40/in.png"
              alt="INDIA"
              sx={{
                width: 24,
                height: 16,
                objectFit: "cover",
                borderRadius: "2px",
              }}
            />

            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#2B3445",
                fontFamily: "Be Vietnam Pro",
              }}
            >
              INDIA
            </Typography>
          </Box>
        </MenuItem>
      </Select>
    </Box>
  );
};

export default WebRegionToggle;
